import Vue from 'vue'
import Vuex from 'vuex'

// 与法规相关的数据和方法存储在regulationData.js中
import {
  regulations
} from './regulations.js'

// 与标准相关的数据和方法存储在standardsData.js中
import {
  standards
} from './standards.js'


// 与标准相关的数据和方法存储在users.js中
import {
  users
} from './users.js'

// 订单
import {
  order
} from './order.js'

// 业务
import {
  business
} from './business.js'

// 业务
import {
  bcm
} from './bcm.js'

// 控制措施
import {
  datacenter
} from './controls/datacenter.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    standards,
    regulations,
    users,
    order,
    business,
    bcm,
    datacenter
  },
})

export default store